import { useTranslation } from 'react-i18next';
import ChatBubble from '../../../components/Chat/Chat';
import mascot from '../../../assets/kitoBuddy/Kito-Asking-When-To-Worry 1.png';

export default function WhenToWorry({ title, disclaimer, options = [] }) {
  const { t } = useTranslation();
  return (
    <div>
      <ChatBubble img={mascot} text={t(title)} outline="#FF2B26" />
      <div className="when__content">
        <p>{t(disclaimer)}</p>
        <div className="when__options">
          <ul>
            {options.map((option) => (
              <li key={option}>{t(option)}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
